import React, { useState } from "react";
import { motion } from "framer-motion";
import { Phone, PaperPlaneTilt, CheckCircle } from "@phosphor-icons/react";
import { submitCallback } from "../lib/api";
import { toast } from "sonner";

export default function CallbackForm({ compact = false, testIdPrefix = "callback" }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) {
      toast.error("Merci de renseigner votre nom et votre téléphone.");
      return;
    }
    setLoading(true);
    try {
      await submitCallback({ name, phone });
      setDone(true);
      toast.success("Demande enregistrée. Nous vous rappelons rapidement.");
    } catch (err) {
      toast.error("Erreur lors de l'envoi. Merci de réessayer.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        data-testid={`${testIdPrefix}-success`}
        className="p-6 rounded-2xl bg-emerald-50 border border-emerald-200 text-center"
      >
        <CheckCircle size={36} weight="fill" className="mx-auto text-emerald-600 mb-2" />
        <h4 className="font-heading font-bold text-slate-900">Demande enregistrée</h4>
        <p className="text-sm text-slate-600 mt-1">
          Un conseiller vous rappelle rapidement.
        </p>
      </motion.div>
    );
  }

  return (
    <form
      onSubmit={onSubmit}
      data-testid={`${testIdPrefix}-form`}
      className={`bg-white p-6 md:p-8 rounded-2xl border border-slate-200 shadow-[0_8px_30px_rgba(0,0,0,0.05)] ${compact ? "" : ""}`}
    >
      {!compact && (
        <>
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-emerald-700 mb-2">
            <Phone size={14} weight="fill" /> Être rappelé
          </div>
          <h3 className="font-heading text-2xl font-bold text-slate-900 mb-1">
            Être rappelé rapidement
          </h3>
          <p className="text-sm text-slate-500 mb-5">
            Laissez-nous vos coordonnées, nous vous rappelons dans la journée.
          </p>
        </>
      )}
      <div className="space-y-3">
        <input
          type="text"
          data-testid={`${testIdPrefix}-name-input`}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Votre nom"
          required
          className="w-full px-4 py-3 rounded-xl border-2 border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none"
        />
        <input
          type="tel"
          data-testid={`${testIdPrefix}-phone-input`}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Téléphone (ex : 06 XX XX XX XX)"
          required
          className="w-full px-4 py-3 rounded-xl border-2 border-slate-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none"
        />
        <button
          type="submit"
          data-testid={`${testIdPrefix}-submit-btn`}
          disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-xl font-semibold btn-secondary-eco disabled:opacity-60"
        >
          {loading ? "Envoi..." : "Être rappelé rapidement"}
          {!loading && <PaperPlaneTilt size={16} weight="fill" />}
        </button>
        <p className="text-xs text-slate-700 text-center font-medium">
          Nous vous rappelons rapidement après votre demande
        </p>
        <p className="text-[11px] text-slate-500 text-center">
          Sans engagement. Aides disponibles selon votre situation.
        </p>
      </div>
    </form>
  );
}
